import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertController, ModalController } from '@ionic/angular';
import { ViewAssetModalPage } from 'src/app/modals/view-asset-modal/view-asset-modal.page';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { BaseAsset } from 'src/app/models/assets/BaseAsset';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionResponse } from 'src/app/models/assets/QuestionResponse';
import { QuestionRule } from 'src/app/models/question-rules/QuestionRule';
import { Scene } from 'src/app/models/Scene';
import { ImageSceneAssetRelation } from 'src/app/models/scene-asset-relations/imageSceneAssetRelation';
import { SceneAssetRelation } from 'src/app/models/scene-asset-relations/SceneAssetRelation';
import { VideoSceneAssetRelation } from 'src/app/models/scene-asset-relations/videoSceneAssetRelation';
import { AssetEvent } from 'src/app/models/vr-events/AssetEvent';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { QuestionRuleService } from 'src/app/services/question-rule.service';
import { ValidationService } from 'src/app/services/validation.service';
import { VrEventTriggerService } from 'src/app/services/vr-event-trigger.service';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { VrEventService } from 'src/app/services/vr-event.service';

@Component({
  selector: 'app-step-quiz-questions',
  templateUrl: './step-quiz-questions.component.html',
  styleUrls: ['./step-quiz-questions.component.scss'],
})
export class StepQuizQuestionsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('assetsOnAssetManagementPage') assetsOnAssetManagementPage: MediaAsset[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('questionProperties') questionProperties: any;
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public paginateConfig: any;
  public paginateConfigAnswers: any;
  public currentEventIndex: number = -1;
  public currentRuleIndex: number = -1;
  public questionEvent: AssetEvent = null;
  public questionRule: QuestionRule = null;

  public responseImageObject: AssetInScene = null;
  public responseVideoObject: AssetInScene = null;
  public responseAudioObject: AssetInScene = null;

  public assetsOnAssetManagementPageList: MediaAsset[] = [];
  public assetsOnAssetManagementPageListCopy: MediaAsset[] = [];
  public assetSearchTerm: string;
  public searchNotFound: boolean = false;

  private _isModalOpen: boolean = false;

  public selectOptions: any;

  public maxQuestionLength: number = 0;
  public maxResponsesLength: number = 0;

  constructor(
    private sanitizer: DomSanitizer,
    public vrEventService: VrEventService,
    public vrEventTypeService: VrEventTypeService,
    public vrEventTriggerService: VrEventTriggerService,
    public questionRuleService: QuestionRuleService,
    public assetTypeService: AssetTypeService,
    public deepCopyService: DeepCopyService,
    public modalController: ModalController,
    public alertController: AlertController,
    public validationService: ValidationService
  ) {
    this.paginateConfig = {
      itemsPerPage: 3,
      currentPage: 1
    };
    this.paginateConfigAnswers = {
      itemsPerPage: 3,
      currentPage: 1
    };

    this.selectOptions = {
      cssClass: 'quizard-select'
    }
  }

  ngOnInit() { 
    this.validateQuestionFontSize(this.getQuestionAsset());
    this.validateResponsesFontSize(this.getQuestionAsset());
  }

  getQuestionAsset(): QuestionAsset {
    return this.assetInScene.assets[this.currentStepInfo.currentQuestionIndex].baseAsset as QuestionAsset;
  }

  getAssetName(sceneAssetRelationId: number): string {
    let asset = this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    if (asset)
      return asset.baseAsset.name;
    else
      return "";
  }

  getSceneName(sceneId: number): string {
    return this.existingScenes.find(s => s.sceneId == sceneId).name;
  }

  getResponseName(responseIndex: number): string {
    let question: QuestionAsset = this.assetInScene.assets[this.currentStepInfo.currentQuestionIndex].baseAsset as QuestionAsset;
    return question.responses[responseIndex].text;
  }

  validateQuestionFontSize(questionAsset: QuestionAsset){
    if(!questionAsset.text) return;

    this.maxQuestionLength = questionAsset.text.length > this.maxQuestionLength ? questionAsset.text.length : this.maxQuestionLength;
    if(this.maxQuestionLength > 125 && (55-this.questionProperties.questionTextSize) > 26)
      this.questionProperties.questionTextSize = 55-26;
  }

  validateResponsesFontSize(questionAsset: QuestionAsset){
    if(!questionAsset.responses) return;

    for(let i: number = 0; i < questionAsset.responses.length; i++){
      let response = questionAsset.responses[i];
      this.maxResponsesLength = response.text.length > this.maxResponsesLength ? response.text.length : this.maxResponsesLength;
    }
    if(this.maxResponsesLength > 60 && (55-this.questionProperties.questionResponsesTextSize) > 20)
      this.questionProperties.questionResponsesTextSize = 55-20;
  }

  // =============== QUESTIONS =============  
  setResponseIsCorrect(event, response: QuestionResponse) {
    let question: QuestionAsset = this.assetInScene.assets[this.currentStepInfo.currentQuestionIndex].baseAsset as QuestionAsset;
    let otherResponses = question.responses.filter(r => r.questionResponseIndex != response.questionResponseIndex);

    for (let index = 0; index < otherResponses.length; index++) {
      otherResponses[index].isCorrect = false;
    }
  }

  removeResponse(index) {
    let question: QuestionAsset = this.assetInScene.assets[this.currentStepInfo.currentQuestionIndex].baseAsset as QuestionAsset
    question.responses.splice(index, 1);

    this.questionProperties.responseFiles[this.currentStepInfo.currentQuestionIndex].splice(index, 1);

    if (question.responses.filter(r => r.isCorrect === true).length <= 0) {
      question.responses[0].isCorrect = true;
    }
  }

  addResponse(baseAsset: QuestionAsset, i: number = 0) {
    let response: any = new QuestionResponse();
    let maxResponseIndex = 0;

    response.isCorrect = i == 1 ? true : false;
    response.text = 'Default Response ' + (i >= 1 ? i : '');
    response.textSize = 30;
    response.hasImage = false;
    response.imageSceneAssetRelationId = 0;
    response.hasVideo = false;
    response.videoSceneAssetRelationId = 0;
    response.hasAudio = false;
    response.audioSceneAssetRelationId = 0;
    response.hasLinkedScene = false;
    response.linkedSceneID = 0;
    response.fontFamily = "../assets/fonts/opensans/OpenSans-Regular-msdf.json";
    response.assets = [];
    
    if(this.editing == true){
      response.new = true;
    }

    for (let i: number = 0; i < baseAsset.responses.length; i++) {
      if (baseAsset.responses[i].questionResponseIndex > maxResponseIndex)
        maxResponseIndex = baseAsset.responses[i].questionResponseIndex;
    }

    response.questionResponseIndex = maxResponseIndex + 1;

    this.addResponseObjects(response);
    this.questionProperties.responseFiles[this.currentStepInfo.currentQuestionIndex].push({imageFiles: null, videoFiles: null, audioFiles: null});

    baseAsset.responses.push(response);
  }

  addResponseObjects(response: QuestionResponse) {
    let imageTypeId = this.assetTypeService.getId('Image');
    let videoTypeId = this.assetTypeService.getId('Video');
    let audioTypeId = this.assetTypeService.getId('Audio');
    let imageAsset = new MediaAsset();
    let videoAsset = new MediaAsset();
    let audioAsset = new MediaAsset();
    let imageAssetInScene = new AssetInScene();
    let videoAssetInScene = new AssetInScene();
    let audioAssetInScene = new AssetInScene();

    imageAsset.assetTypeId = imageTypeId;
    imageAsset.name = 'Default Response - Image';
    videoAsset.assetTypeId = videoTypeId;
    videoAsset.name = 'Default Response - Video';
    audioAsset.assetTypeId = audioTypeId;
    audioAsset.name = 'Default Response - Audio';

    imageAssetInScene.baseAsset = imageAsset;
    imageAssetInScene.sceneAssetRelation = new SceneAssetRelation();
    this.setUpAssetScale(imageAssetInScene.sceneAssetRelation, '1.5', '0.75' ,'0.1');
    this.setUpAssetPosition(imageAssetInScene.sceneAssetRelation, '0', '0.525', '0.5');
    imageAssetInScene.toBeRemoved = false;
    imageAssetInScene.events = [];

    videoAssetInScene.baseAsset = videoAsset;
    videoAssetInScene.sceneAssetRelation = new SceneAssetRelation();
    this.setUpAssetScale(videoAssetInScene.sceneAssetRelation, '1.5', '0.75' ,'0.1');
    this.setUpAssetPosition(videoAssetInScene.sceneAssetRelation, '0', '0.525', '0.5');
    videoAssetInScene.toBeRemoved = false;
    videoAssetInScene.events = [];

    audioAssetInScene.baseAsset = audioAsset;
    audioAssetInScene.sceneAssetRelation = new SceneAssetRelation();
    this.setUpAssetScale(audioAssetInScene.sceneAssetRelation, '0.5', '0.25' ,'0.1');
    this.setUpAssetPosition(audioAssetInScene.sceneAssetRelation, '0', '0.25', '0.5');
    audioAssetInScene.toBeRemoved = false;
    audioAssetInScene.events = [];

    response.assets.push(imageAssetInScene);
    response.assets.push(videoAssetInScene);
    response.assets.push(audioAssetInScene);
  }

  deleteQuestion() {
    this.assetInScene.assets.splice(this.currentStepInfo.currentQuestionIndex, 1);
    this.currentStepInfo.currentQuestionIndex = 0;
    this.currentStepInfo.questionActions = false;
    this.currentStepInfo.answerActions = false;
    this.currentStepInfo.addMedia = false;
    this.questionProperties.responseFiles.splice(this.currentStepInfo.currentQuestionIndex, 1);
  }

  manageQuestionActions() {
    let currentQuestion: AssetInScene = this.assetInScene.assets[this.currentStepInfo.currentQuestionIndex];

    this.currentStepInfo.currentQuestionEvents = this.deepCopyService.deepCopy(currentQuestion.events);
    this.currentStepInfo.currentQuestionRules = this.deepCopyService.deepCopy(currentQuestion.questionRules);

    this.goToQuestionActions();
  }

  goToQuestionActions() {
    this.currentStepInfo.questionActions = true;
    this.currentStepInfo.answerActions = false;
    this.currentStepInfo.addMedia = false;

    this.resetQuestionEvent();
  }

  goToAnswerActions() {
    this.currentStepInfo.questionActions = false;
    this.currentStepInfo.answerActions = true;
    this.currentStepInfo.addMedia = false;

    this.resetQuestionRule();
  }

  validateQuestionScore(event, assetInScene: AssetInScene) {
    var questionAsset: QuestionAsset = assetInScene.baseAsset as QuestionAsset;
    var value = +event.target.value;
    value = this.validationService.validateMinValue(value, 0.5);
    value = this.validationService.validateMaxValue(value, 5);
    if (value != Math.floor(value)) {
      value = Math.floor(value) + 0.5;
    }
    questionAsset.score = Number(value);
  }

  validateCorrectMessage(event, questionAsset: QuestionAsset){
    questionAsset.correctMessage = questionAsset.correctMessage.replace(/\r?\n|\r/g, " ");
  }

  validateIncorrectMessage(event, questionAsset: QuestionAsset){
    questionAsset.incorrectMessage = questionAsset.incorrectMessage.replace(/\r?\n|\r/g, " ");
  }

  validateQuestionText(questionAsset: QuestionAsset){
    questionAsset.text = questionAsset.text ? questionAsset.text : "";
    questionAsset.text = this.validationService.removeExcessLineBreaks(questionAsset.text);

    this.validateQuestionFontSize(questionAsset);
  }

  validateResponseText(questionAsset: QuestionAsset, responseIndex: number){
    let response = questionAsset.responses[responseIndex];
    response.text = response.text ? response.text : "";
    response.text = this.validationService.removeExcessLineBreaks(response.text);

    this.validateResponsesFontSize(questionAsset);
  }

  // =============== ACTIONS =============  
  resetQuestionEvent() {
    this.currentEventIndex = -1;
    this.questionEvent = this.vrEventService.getNewVrEvent() as AssetEvent;
  }

  resetQuestionRule() {
    this.currentRuleIndex = -1;
    this.questionRule = this.questionRuleService.getNewQuestionRule();
  }

  getEventTypes() {
    return this.vrEventTypeService.types;
  }

  getActiveAssetsInScene(): AssetInScene[] {
    return this.existingAssetsInScene.filter(a => a.toBeRemoved !== true 
      && a.sceneAssetRelation.sceneId == this.assetInScene.sceneAssetRelation.sceneId 
      && a.sceneAssetRelation.sceneAssetRelationId !== this.assetInScene.sceneAssetRelation.sceneAssetRelationId);
  }

  getActiveMediaAssetsInScene(): AssetInScene[] {
    let videoTypeId = this.assetTypeService.getId('Video');
    let audioTypeId = this.assetTypeService.getId('Audio');
    return this.existingAssetsInScene.filter(a => a.toBeRemoved !== true 
      && a.sceneAssetRelation.sceneId == this.assetInScene.sceneAssetRelation.sceneId 
      && a.sceneAssetRelation.sceneAssetRelationId !== this.assetInScene.sceneAssetRelation.sceneAssetRelationId 
      && [videoTypeId,audioTypeId].includes(a.baseAsset.assetTypeId));
  }

  getActiveScenes(): Scene[] {
    return this.existingScenes.filter(s => s.active == true);
  }

  getEventType(eventTypeId) {
    return this.vrEventTypeService.getType(eventTypeId);
  }

  isObjectEventType(eventTypeId: number) {
    return this.vrEventService.isObjectEventType(eventTypeId);
  }

  isMediaEventType(eventTypeId: number) {
    return this.vrEventService.isMediaEventType(eventTypeId);
  }

  editAction(index: number) {
    let questionEvents = this.currentStepInfo.currentQuestionEvents;
    this.currentEventIndex = index;

    this.questionEvent = this.deepCopyService.deepCopy(questionEvents[this.currentEventIndex]);
  }

  cancelAction() {
    this.resetQuestionEvent();
  }

  saveAction() {
    let questionEvents = this.currentStepInfo.currentQuestionEvents;

    if (this.questionEvent.eventTypeId <= 0 
      || !this.questionEvent.linkedContentId || Number(this.questionEvent.linkedContentId) <= 0 
      || !this.questionEvent.eventTriggerId || this.questionEvent.eventTriggerId <= 0)
      return;

    if (this.currentEventIndex >= 0) {
      questionEvents[this.currentEventIndex] = this.deepCopyService.deepCopy(this.questionEvent);
    } else {
      questionEvents.push(this.deepCopyService.deepCopy(this.questionEvent));
    }

    this.resetQuestionEvent();
  }

  deleteAction(index: number) {
    let questionEvents = this.currentStepInfo.currentQuestionEvents;

    questionEvents.splice(index, 1);
  }

  isQuestionSetAsset(sceneAssetRelationId: number): boolean {
    let linkedAssetInScene: AssetInScene = this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    if (!linkedAssetInScene) {
      return false;
    }
    let assetType = this.assetTypeService.getType(linkedAssetInScene.baseAsset.assetTypeId);
    if (assetType == 'QuestionSet') {
      return true;
    } else {
      return false;
    }
  }

  getLinkedAssetInScene(questionRule: QuestionRule): AssetInScene {
    return this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == questionRule.linkedSceneAssetRelationId);
  }

  getLinkedQuestionName(questionRule: QuestionRule): string {
    let questionSetAsset = this.getLinkedAssetInScene(questionRule);
    if (questionSetAsset && questionSetAsset.assets[questionRule.linkedQuestionIndex]) {
      return 'Question ' + (questionRule.linkedQuestionIndex + 1).toString();
    } else {
      return '';
    }
  }

  isRestartQuestionType(typeId: number): boolean {
    let type = this.questionRuleService.getQuestionRuleType(typeId)
    if (type) {
      return type == 'Restart Question';
    } else {
      return false;
    }
  }

  editRule(index: number) {
    let questionRules = this.currentStepInfo.currentQuestionRules;
    this.currentRuleIndex = index;

    this.questionRule = this.deepCopyService.deepCopy(questionRules[this.currentRuleIndex]);
  }

  cancelRule() {
    this.resetQuestionRule();
  }

  saveRule() {
    let questionRules: QuestionRule[] = this.currentStepInfo.currentQuestionRules;

    if (this.questionRule.questionResponseIndex < 0 || this.questionRule.questionRuleTypeId <= 0
      || (!this.isRestartQuestionType(this.questionRule.questionRuleTypeId) && Number(this.questionRule.linkedSceneAssetRelationId) <= 0)
      || (this.isQuestionSetAsset(Number(this.questionRule.linkedSceneAssetRelationId)) && this.questionRule.linkedQuestionIndex < 0))
      return;

    if (this.currentRuleIndex >= 0) {
      questionRules[this.currentRuleIndex] = this.deepCopyService.deepCopy(this.questionRule);
    } else {
      questionRules.push(this.deepCopyService.deepCopy(this.questionRule));
    }

    this.resetQuestionRule();
  }

  deleteRule(index: number) {
    let questionRules = this.currentStepInfo.currentQuestionRules;

    questionRules.splice(index, 1);
  }

  // =============== ADD MEDIA ============= 
  changeIfDefaultName(asset: BaseAsset) {
    let pre: string = this.currentStepInfo.currentResponse.text;
    if (asset.name.toLowerCase().startsWith('default response') && 
      (asset.name.toLowerCase().endsWith('image') || asset.name.toLowerCase().endsWith('video') || asset.name.toLowerCase().endsWith('audio'))) {
      asset.name = '';
    }
  }

  changeMedia(questionResponseIndex: number) {
    let questionAsset = this.assetInScene.assets[this.currentStepInfo.currentQuestionIndex].baseAsset as QuestionAsset;
    this.currentStepInfo.currentQuestionResponseIndex = questionResponseIndex;
    this.currentStepInfo.currentResponse = this.deepCopyService.deepCopy(questionAsset.responses[questionResponseIndex]);
    this.currentStepInfo.addMedia = true;
    this.currentStepInfo.currentResponse.imageFiles = null;
    this.currentStepInfo.currentResponse.videoFiles = null;
    this.currentStepInfo.currentResponse.audioFiles = null;

    let imageTypeId = this.assetTypeService.getId('Image');
    let videoTypeId = this.assetTypeService.getId('Video');
    let audioTypeId = this.assetTypeService.getId('Audio');
    this.responseImageObject = this.currentStepInfo.currentResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === imageTypeId);
    this.responseVideoObject = this.currentStepInfo.currentResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === videoTypeId);
    this.responseAudioObject = this.currentStepInfo.currentResponse.assets.find(a => a.toBeRemoved !== true && a.baseAsset.assetTypeId === audioTypeId);
    this.changeIfDefaultName(this.responseImageObject.baseAsset);
    this.changeIfDefaultName(this.responseVideoObject.baseAsset);
    this.changeIfDefaultName(this.responseAudioObject.baseAsset);

    //CHANGE THE SRC SO IT CAN WORK ON MEDIA LOAD
    let imageAsset: any = this.responseImageObject.baseAsset;
    let videoAsset: any = this.responseVideoObject.baseAsset;
    if(imageAsset.src && imageAsset.src != "")
      imageAsset.srcToView = this.sanitizer.bypassSecurityTrustUrl(imageAsset.src);
    if(videoAsset.src && videoAsset.src != "")
      videoAsset.srcToView = this.sanitizer.bypassSecurityTrustUrl(videoAsset.src);
  }

  clearResponseObjectSrc(object: string) {
    switch (object) {
      case 'image': {
        let imageAsset: MediaAsset = this.responseImageObject.baseAsset as MediaAsset;

        this.currentStepInfo.currentResponse.hasImage = false;
        this.currentStepInfo.currentResponse.imageUploaded = false;
        this.currentStepInfo.currentResponse.imageFiles = null;
        this.currentStepInfo.currentResponse.imageFromMediaManagementPageId = -1;
        imageAsset.name = '';
        imageAsset.src = null;

        break;
      }
      case 'video': {
        let videoAsset: MediaAsset = this.responseImageObject.baseAsset as MediaAsset;

        this.currentStepInfo.currentResponse.hasVideo = false;
        this.currentStepInfo.currentResponse.videoUploaded = false;
        this.currentStepInfo.currentResponse.videoFiles = null;
        this.currentStepInfo.currentResponse.videoFromMediaManagementPageId = -1;
        videoAsset.name = '';
        videoAsset.src = null;

        break;
      }
      case 'audio': {
        let audioAsset: MediaAsset = this.responseImageObject.baseAsset as MediaAsset;

        this.currentStepInfo.currentResponse.hasAudio = false;
        this.currentStepInfo.currentResponse.audioUploaded = false;
        this.currentStepInfo.currentResponse.audioFiles = null;
        this.currentStepInfo.currentResponse.audioFromMediaManagementPageId = -1;
        audioAsset.name = '';
        audioAsset.src = null;

        break;
      }
    }
  }

  clearResponseLinkedScene() {
    this.currentStepInfo.currentResponse.linkedSceneID = 0;
  }

  linkedSceneChanged(event){
    if(this.currentStepInfo.currentResponse.linkedSceneID > 0){
      this.currentStepInfo.currentResponse.hasLinkedScene = true;
    }
  }

  previewResponseObjectSrc(object: string) {
    switch (object) {
      case 'image': {
        this.previewAsset(this.responseImageObject.baseAsset as MediaAsset);
        break;
      }
      case 'video': {
        this.previewAsset(this.responseVideoObject.baseAsset as MediaAsset);
        break;
      }
      case 'audio': {
        this.previewAsset(this.responseAudioObject.baseAsset as MediaAsset);
        break;
      }
    }
  }

  async previewAsset(mediaAsset: any) {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    var oldSrc = mediaAsset.src;
    mediaAsset.src = this.sanitizer.bypassSecurityTrustUrl(oldSrc);

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetTypeService.getType(mediaAsset.assetTypeId) + '-modal',
      componentProps: {
        "assetModalData": mediaAsset
      }
    });

    modal.onDidDismiss().then(() => {
      mediaAsset.src = oldSrc;
      this._isModalOpen = false;
    });

    return await modal.present();

  }

  editResponseObjectProperties(object: string) {
    this.currentStepInfo.addMediaFromMediaManagementPage = false;
    this.currentStepInfo.editResponseObjectProperties = true;
    this.currentStepInfo.responseObjectType = object;

    switch (object) {
      case 'image': {
        this.currentStepInfo.responseObject = this.deepCopyService.deepCopy(this.responseImageObject);
        this.currentStepInfo.responseObjectToSave = this.responseImageObject;

        break;
      }
      case 'video': {
        this.currentStepInfo.responseObject = this.deepCopyService.deepCopy(this.responseVideoObject);
        this.currentStepInfo.responseObjectToSave = this.responseVideoObject;

        break;
      }
      case 'audio': {
        this.currentStepInfo.responseObject = this.deepCopyService.deepCopy(this.responseAudioObject);
        this.currentStepInfo.responseObjectToSave = this.responseAudioObject;

        break;
      }
    }
  }

  async selectResponseObject(objectId: string) {
    let input = document.querySelector('#response-' + objectId + '-obj-input');

    const alert = await this.alertController.create({
      header: 'Choose ' + objectId + ' media',
      message: 'You can browse for a file on your computer or select a file from the media management page.',
      cssClass: 'leave-alert quizard-alert',
      buttons: [{
        text: 'Add ' + objectId + ' from media management page',
        cssClass: '',
        handler: async () => {
          this.currentStepInfo.addMediaFromMediaManagementPage = true;
          this.currentStepInfo.editResponseObjectProperties = false;
          this.currentStepInfo.responseObjectType = objectId;
          switch (objectId) {
            case 'image': {
              this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter(x => x.assetTypeId == this.responseImageObject.baseAsset.assetTypeId));
              this.assetsOnAssetManagementPageListCopy = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter(x => x.assetTypeId == this.responseImageObject.baseAsset.assetTypeId));
              this.currentStepInfo.assetIDToCopy = this.currentStepInfo.currentResponse.imageFromMediaManagementPageId;
              this.currentStepInfo.responseObject = this.responseImageObject;
              break;
            }
            case 'video': {
              this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter(x => x.assetTypeId == this.responseVideoObject.baseAsset.assetTypeId));
              this.assetsOnAssetManagementPageListCopy = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter(x => x.assetTypeId == this.responseVideoObject.baseAsset.assetTypeId));
              this.currentStepInfo.assetIDToCopy = this.currentStepInfo.currentResponse.videoFromMediaManagementPageId;
              this.currentStepInfo.responseObject = this.responseVideoObject;
              break;
            }
            case 'audio': {
              this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter(x => x.assetTypeId == this.responseAudioObject.baseAsset.assetTypeId));
              this.assetsOnAssetManagementPageListCopy = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPage.filter(x => x.assetTypeId == this.responseAudioObject.baseAsset.assetTypeId));
              this.currentStepInfo.assetIDToCopy = this.currentStepInfo.currentResponse.audioFromMediaManagementPageId;
              this.currentStepInfo.responseObject = this.responseAudioObject;
              break;
            }
          }
        }
      }, {
        text: 'Upload from computer',
        cssClass: '',
        handler: () => {
          if (input) {
            input.click();
          }
        }
      }
      ]
    });
    await alert.present();
  }

  responseObjectSelected(event, object: string) {
    if (event.target.files.length == 0) return;
    this.validationService.setFileType(event);

    switch (object) {
      case 'image': {
        let imageAsset: any = this.responseImageObject.baseAsset as MediaAsset;

        if (!this.validationService.doesUploadedFileMatchAssetType(imageAsset.assetTypeId)) {
          this.validationService.createAlert('Wrong Media Type Uploaded.');
          return;
        } else if (!this.validationService.isFileFormatCorrect(imageAsset.assetTypeId)) {
          this.validationService.createAlert('Unsupported File Format.');
          return;
        }

        imageAsset.mediaFileExtension = this.getFileExtension(event.target.files[0].name);
        imageAsset.name = String(event.target.files[0].name).substring(0, 40);
        imageAsset.src = URL.createObjectURL(event.target.files[0]);
        imageAsset.srcToView = this.sanitizer.bypassSecurityTrustUrl(imageAsset.src);

        this.currentStepInfo.currentResponse.hasImage = true;
        this.currentStepInfo.currentResponse.imageUploaded = true;
        this.currentStepInfo.currentResponse.imageFiles = event.target.files;
        this.currentStepInfo.currentResponse.imageFromMediaManagementPageId = -1;

        break;
      }
      case 'video': {
        let videoAsset: any = this.responseVideoObject.baseAsset as MediaAsset;

        if (!this.validationService.doesUploadedFileMatchAssetType(videoAsset.assetTypeId)) {
          this.validationService.createAlert('Wrong Media Type Uploaded.');
          return;
        } else if (!this.validationService.isFileFormatCorrect(videoAsset.assetTypeId)) {
          this.validationService.createAlert('Unsupported File Format.');
          return;
        }

        videoAsset.mediaFileExtension = this.getFileExtension(event.target.files[0].name);
        videoAsset.name = String(event.target.files[0].name).substring(0, 40);
        videoAsset.src = URL.createObjectURL(event.target.files[0]);
        videoAsset.srcToView = this.sanitizer.bypassSecurityTrustUrl(videoAsset.src);

        this.currentStepInfo.currentResponse.hasVideo = true;
        this.currentStepInfo.currentResponse.videoUploaded = true;
        this.currentStepInfo.currentResponse.videoCompress = true;
        this.currentStepInfo.currentResponse.videoFiles = event.target.files;
        this.currentStepInfo.currentResponse.videoFromMediaManagementPageId = -1;

        break;
      }
      case 'audio': {
        let audioAsset: any = this.responseAudioObject.baseAsset as MediaAsset;

        if (!this.validationService.doesUploadedFileMatchAssetType(audioAsset.assetTypeId)) {
          this.validationService.createAlert('Wrong Media Type Uploaded.');
          return;
        } else if (!this.validationService.isFileFormatCorrect(audioAsset.assetTypeId)) {
          this.validationService.createAlert('Unsupported File Format.');
          return;
        }

        audioAsset.mediaFileExtension = this.getFileExtension(event.target.files[0].name);
        audioAsset.name = String(event.target.files[0].name).substring(0, 40);
        audioAsset.src = URL.createObjectURL(event.target.files[0]);
        audioAsset.srcToView = this.sanitizer.bypassSecurityTrustUrl(audioAsset.src);

        this.currentStepInfo.currentResponse.hasAudio = true;
        this.currentStepInfo.currentResponse.audioUploaded = true;
        this.currentStepInfo.currentResponse.audioFiles = event.target.files;
        this.currentStepInfo.currentResponse.audioFromMediaManagementPageId = -1;
        break;
      }
    }
  }

  getFileExtension(fileName: string): string {
    return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
  }

  searchByAsset(event) {
    let name: string = event.target.value ? event.target.value : '';

    this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageListCopy);
    var assets = this.assetsOnAssetManagementPageList.filter(x => x.name.toLowerCase().includes(name.toLowerCase()));
    if (assets.length === 0) {
      this.searchNotFound = true;
      this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageListCopy);
    }
    else {
      this.searchNotFound = false;
      this.assetsOnAssetManagementPageList = assets;
    }
  }

  changeResponsePropertyValue(prop: string, valueToAdd: number){
    let oldValue: number = Number(this.currentStepInfo.responseObject.sceneAssetRelation[prop]);
    this.currentStepInfo.responseObject.sceneAssetRelation[prop] = String(oldValue + valueToAdd);
    this.validateResponseProperties();
  }

  validateResponseProperties(){
    let assetType = this.assetTypeService.getType(this.currentStepInfo.responseObject.baseAsset.assetTypeId);
    let xPos: number = Number(this.currentStepInfo.responseObject.sceneAssetRelation.xPos);
    let yPos: number = Number(this.currentStepInfo.responseObject.sceneAssetRelation.yPos);
    let xScale: number = Number(this.currentStepInfo.responseObject.sceneAssetRelation.xScale);
    let yScale: number = Number(this.currentStepInfo.responseObject.sceneAssetRelation.yScale);

    if(xPos > 1) xPos = 1;
    else if(xPos < -1) xPos = -1;

    if(yPos > 1) yPos = 1;
    else if(yPos < -1) yPos = -1;

    if(xScale > 2) xScale = 2;
    else if(xScale < 0.1) xScale = 0.1;

    if(this.currentStepInfo.responseObjectType == 'image'){
      let imageSceneAssetRelation = this.responseImageObject.sceneAssetRelation as ImageSceneAssetRelation;
      if(imageSceneAssetRelation.aspectRatioConstant)
        yScale = xScale * imageSceneAssetRelation.aspectRatioConstant;
    }

    if(this.currentStepInfo.responseObjectType == 'video'){
      let videoSceneAssetRelation = this.responseImageObject.sceneAssetRelation as VideoSceneAssetRelation;
      if(videoSceneAssetRelation.aspectRatioConstant)
        yScale = xScale * videoSceneAssetRelation.aspectRatioConstant;
    }

    if(yScale > 2) yScale = 2;
    else if(yScale < 0.1) yScale = 0.1;

    if(assetType === 'Audio'){
      yScale = xScale / 2;
    }

    xPos = Number(xPos.toFixed(3));
    yPos = Number(yPos.toFixed(3));
    xScale = Number(xScale.toFixed(3));
    yScale = Number(yScale.toFixed(3));

    this.currentStepInfo.responseObject.sceneAssetRelation = {
      ...this.currentStepInfo.responseObject.sceneAssetRelation,
      xPos: String(xPos),
      yPos: String(yPos),
      xScale: String(xScale),
      yScale: String(yScale)
    };

    this.setUpSceneAssetRelationScaleAndPosition();
  }

  setUpSceneAssetRelationScaleAndPosition(){
    let { xPos, yPos, zPos, xScale, yScale, zScale} = this.currentStepInfo.responseObject.sceneAssetRelation;
    this.currentStepInfo.responseObject.sceneAssetRelation.position = `${xPos} ${yPos} ${zPos}`;
    this.currentStepInfo.responseObject.sceneAssetRelation.scale = `${xScale} ${yScale} ${zScale}`;
  }

  setUpAssetScale(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xScale = x;
    sceneAssetRelation.yScale = y;
    sceneAssetRelation.zScale = z;
    sceneAssetRelation.scale = x + ' ' + y + ' ' + z;
  }

  setUpAssetPosition(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xPos = x.toString();
    sceneAssetRelation.yPos = y.toString();
    sceneAssetRelation.zPos = z.toString();
    sceneAssetRelation.position = x + ' ' + y + ' ' + z;
  }

  onMediaLoad(event, object: string) {
    switch (object) {
      case 'image': {
        let imageWidth: number = event.target.naturalWidth;
        let imageHeight: number = event.target.naturalHeight;
        let imageSceneAssetRelation = this.responseImageObject.sceneAssetRelation as ImageSceneAssetRelation;
        let xScale: number = Number(imageSceneAssetRelation.xScale);

        imageSceneAssetRelation.aspectRatioConstant = imageWidth == 0 ? (imageHeight == 0 ? 0.5 : imageHeight) : ((imageHeight == 0 ? 0.5 : imageHeight) / imageWidth);
        imageSceneAssetRelation.yScale = (xScale * imageSceneAssetRelation.aspectRatioConstant).toFixed(3);
        imageSceneAssetRelation.scale = `${imageSceneAssetRelation.xScale} ${imageSceneAssetRelation.yScale} ${imageSceneAssetRelation.zScale}`;

        break;
      }
      case 'video': {
        let videoWidth: number = event.target.videoWidth;
        let videoHeight: number = event.target.videoHeight;
        let videoSceneAssetRelation = this.responseVideoObject.sceneAssetRelation as VideoSceneAssetRelation;
        let xScale: number = Number(videoSceneAssetRelation.xScale);

        videoSceneAssetRelation.aspectRatioConstant = videoWidth == 0 ? (videoHeight == 0 ? 0.5 : videoHeight) : ((videoHeight == 0 ? 0.5 : videoHeight) / videoWidth);
        videoSceneAssetRelation.yScale = (xScale * videoSceneAssetRelation.aspectRatioConstant).toFixed(3);
        videoSceneAssetRelation.scale = `${videoSceneAssetRelation.xScale} ${videoSceneAssetRelation.yScale} ${videoSceneAssetRelation.zScale}`;

        break;
      }
    }
  }

}
